import { CSSResultGroup, TemplateResult, html } from 'lit';
import {
  LightDomStyles,
  MobileController,
  OutlineElement,
  SlotsController,
} from '@phase2/outline-core';
import { customElement } from 'lit/decorators.js';
import componentStyles from './outline-workday-block.css.lit';
import buttonStyles from '../outline-button-baseline/outline-button-baseline.css.lit';
import '../outline-icon-baseline/outline-icon-baseline';
import '../outline-button-baseline/outline-button-baseline';
import { classMap } from 'lit/directives/class-map.js';

/**
 * The OutlineWorkdayBlock component
 * @element outline-workday-block
 */
@customElement('outline-workday-block')
export class OutlineWorkdayBlock extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles, buttonStyles];

  lightDomStyles = new LightDomStyles(
    this,
    componentStyles,
    this.tagName.toLowerCase()
  );

  slots = new SlotsController(this);
  private mobileController = new MobileController(this, 'lg');

  render(): TemplateResult {
    const isMobile = this.mobileController.isMobile;
    return html`
      <div
        class="
      ${classMap({
          container: true,
        })}"
      >
        ${isMobile ? this.slots.conditionalSlot('heading', false) : null}
        <div class="content-wrapper">
          <div class="content">
            ${this.slots.conditionalSlot('heading', false)}
            ${this.slots.conditionalSlot('body', false)}
          </div>
          <div class="figure-cta-container">
            <div class="figure">
              ${this.slots.conditionalSlot('image', false)}
            </div>
            ${this.slots.conditionalSlot('cta', false)}
          </div>
        </div>
      </div>
    `;
  }
}
